import styled from "styled-components/macro";
import { SectionContent } from "../Section";

export const AlertaIcon = styled.em`
  color: ${({ theme }) => theme.color.brandPrimary.dark};
  font-size: 36px;
`;
export const AlertGridIconConteiner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const AlertGrid = styled.div`
  margin: 0 !important;
  padding: 0 !important;
`;

export default styled(SectionContent)``;
